import store from '@/store/index'

export default {}

/**
 * Returns the full state object for the specified module.
 *
 * @param module String
 *
 * @returns Object
 */
export const get = (module) => {
  return store.getters[`${module}/get`]
}

/**
 * Returns an array of notes for the specified module.
 *
 * @param module String
 *
 * @returns Array
 */
export const notes = (module) => {
  return store.getters[`${module}/notes`]
}

/**
 * Returns the number of notes.
 *
 * @param module String
 *
 * @returns Number
 */
export const notesCount = (module) => {
  return store.getters[`${module}/notes`].length
}

/**
 * Finds and returns a note by id or undefined if not found.
 *
 * @param module String
 * @param id     Number
 *
 * @returns Array
 */
export const noteById = (module, id) => {
  return store.getters[`${module}/notes`].find(
    note => note.id === id
  )
}

/**
 * Finds and returns a note by index or undefined if not found.
 *
 * @param module String
 * @param index  Number
 *
 * @returns Array
 */
export const noteByIndex = (module, index) => {
  let notes = store.getters[`${module}/notes`]
  if (index < notes.length) {
    return notes[index]
  } else {
    return undefined
  }
}

/**
 * Returns the current form warning.
 *
 * @param module String
 *
 * @return string
 */
export const warning = (module) => {
  return store.getters[`${module}/warning`]
}

/**
 * Returns the newest (last) note in the list of notes.
 *
 * @param module String
 *
 * @returns Object
 */
export const newest = (module) => {
  return notes[store.getters[`${module}/get`].length - 1]
}

/**
 * API request to create a new note. The payload must be in the format:
 * { url: String, data: Object }
 *
 * @param module  String
 * @param payload Object
 */
export const post = (module, payload) => {
  return store.dispatch(`${module}/post`, payload)
}

/**
 * Set an array of notes.
 *
 * @param module String
 * @param notes  Array
 */
export const setNotes = (module, notes) => {
  store.commit(`${module}/setNotes`, notes)
}

/**
 * Add a new note.
 *
 * @param module String
 * @param note   Object
 */
export const add = (module, note) => {
  store.commit(`${module}/add`, note)
}

/**
 * Find a note by id and remove it.
 *
 * @param module  String
 * @param id      Number
 */
export const removeById = (module, id) => {
  store.commit(`${module}/removeById`, id)
}

/**
 * Find a note by id and remove it.
 *
 * @param module  String
 * @param index   Number
 */
export const removeByIndex = (module, index) => {
  store.commit(`${module}/removeByIndex`, index)
}

/**
 * Clears both the notes from the state.
 *
 * @param module String
 */
export const purge = (module) => {
  store.commit(`${module}/purge`)
}

/**
 * Sets the isAdding form state.
 *
 * @param module   String
 * @param isAdding Boolean
 */
export const setIsAdding = (module, isAdding) => {
  store.commit(`${module}/setIsAdding`, isAdding)
}

/**
 * Sets the form warning.
 *
 * @param module  String
 * @param warning String
 */
export const setWarning = (module, warning) => {
  store.commit(`${module}/setWarning`, warning)
}

/**
 * Resets the form state.
 *
 * @param module   String
 */
export const resetFormState = (module) => {
  store.commit(`${module}/resetFormState`)
}



// WEBPACK FOOTER //
// ./src/store/notes/notes.helpers.js